// Local storage keys

export const LOCALE_LSK = 'i18nextLng';

// CPMS BO /////////////////////////////////////////////////////////////////////

export const CHARGE_POINT_FILTERS_LSK = 'filters:charge-points';
export const TRANSACTION_FILTERS_LSK = 'filters:transactions';
export const LOCATION_FILTERS_LSK = 'filters:locations';
export const TOKEN_FILTERS_LSK = 'filters:tokens';
export const ROLE_FILTERS_LSK = 'filters:roles';
export const TARIFF_FILTERS_LSK = 'filters:tariffs';
export const NETWORK_FILTERS_LSK = 'filters:networks';
export const USER_FILTERS_LSK = 'filters:users';
export const CHANNEL_FILTERS_LSK = 'filters:channels';
export const CUSTOMER_FILTERS_LSK = 'filters:customers';
export const INVOICE_FILTERS_LSK = 'filters:invoices';
export const CHARGE_POINT_TRANSACTION_FILTERS_LSK =
  'filters:charge-point-transactions';
export const CHARGE_POINT_LIST_OPTIONS_LSK = 'options:charge-points-list';
export const CHANNEL_LIST_OPTIONS_LSK = 'options:channels-list';
export const CUSTOMER_LIST_OPTIONS_LSK = 'options:customers-list';
export const INVOICE_LIST_OPTIONS_LSK = 'options:invoices-list';
export const LOCATION_LIST_OPTIONS_LSK = 'options:locations-list';
export const NETWORK_LIST_OPTIONS_LSK = 'options:networks-list';
export const ROLE_LIST_OPTIONS_LSK = 'options:roles-list';
export const TARIFF_LIST_OPTIONS_LSK = 'options:tariffs-list';
export const TOKEN_LIST_OPTIONS_LSK = 'options:tokens-list';
export const TRANSACTION_LIST_OPTIONS_LSK = 'options:transactions-list';
export const USER_LIST_OPTIONS_LSK = 'options:users-list';

// EMSP BO /////////////////////////////////////////////////////////////////////

export const EMSP_BO_CHARGING_SESSION_FILTERS_LSK =
  'filters:emsp-bo-charging-sessions';
export const EMSP_BO_INVOICE_FILTERS_LSK = 'filters:emsp-bo-invoice';
export const EMSP_BO_LOCATION_FILTERS_LSK = 'filters:emsp-bo-locations';
export const EMSP_BO_USER_FILTERS_LSK = 'filters:emsp-bo-users';
export const EMSP_BO_RFID_BADGE_ORDER_FILTERS_LSK =
  'filters:emsp-bo-rfid-badge-orders';
export const EMSP_BO_CHARGING_SESSION_LIST_OPTIONS_LSK =
  'options:emsp-bo-charging-sessions-list';
export const EMSP_BO_EMSP_USER_LIST_OPTIONS_LSK =
  'options:emsp-bo-emsp-users-list';
export const EMSP_BO_INVOICE_LIST_OPTIONS_LSK = 'options:emsp-bo-invoices-list';
export const EMSP_BO_RFID_BADGE_ORDER_LIST_OPTIONS_LSK =
  'options:emsp-bo-rfid-badge-orders-list';
export const EMSP_BO_TARIFF_LIST_OPTIONS_LSK = 'options:emsp-bo-tariffs-list';
export const EMSP_BO_TARIFF_FILTERS_LSK = 'filters:emsp-bo-tariffs';
